/* eslint-disable prettier/prettier */
<template>
    <div>
        <md-card>
            <md-card-content>
              
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <md-steppers md-sync-route :md-vertical="isVertical" md-linear>

                                <md-step :to="firstMajorStepPath" id="first" md-label="Details" md-description="Core Info">
                                    <div v-if="currentStep == 'details'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <!--<div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50">-->
                                        <building-details v-if="stepIndex === 0" :details="building.details"></building-details>
                                        <building-contacts v-else-if="stepIndex === 1" :contacts="building.contacts" :name="building.details.name"></building-contacts>
                                        <building-address v-else-if="stepIndex === 2" :address="building.address" :location="building.location" :name="building.details.name"></building-address>
                                        <building-location v-else-if="stepIndex === 3" :location="building.location" :name="building.details.name"></building-location>
                                        <building-service-charge v-else-if="stepIndex === 4" :serviceCharge="building.serviceCharge"></building-service-charge>
                                        <!--</div>-->
                                    </div>
                                </md-step>


                                <md-step :to="secondMajorStepPath" id="second" md-label="Amenties" md-description="Choose amenties">
                                    <div v-if="currentStep == 'amenities'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <div class="md-layout-item md-small-size-100">
                                            <building-amenities v-if="stepIndex === 5" :groups="building.amenities.groups"></building-amenities>
                                            <building-amenities-details v-else-if="stepIndex === 6" :amenities="building.amenities"></building-amenities-details>
                                            <building-visitor-process v-else-if="stepIndex === 7" :visitorProcess="building.visitorProcess"></building-visitor-process>
                                        </div>
                                    </div>
                                </md-step>


                                <md-step :to="thirdMajorStepPath" id="third" md-label="Files" md-description="Upload files for building">
                                    <div v-if="currentStep == 'files'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <div class="md-layout-item md-small-size-100">
                                            <file-pond-upload v-if="stepIndex === 8" ref="filePondUpload"></file-pond-upload>
                                            <building-files-info v-else-if="stepIndex === 9" :files="building.files"></building-files-info>
                                        </div>
                                    </div>
                                </md-step>


                                <md-step :to="fourthMajorStepPath" id="fourth" md-label="Tenants" md-description="Provide tenant info">
                                    <div v-if="currentStep == 'tenants'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <div class="md-layout-item md-small-size-100">
                                            <building-tenants v-if="stepIndex === 10" :tenants="building.tenants"></building-tenants>
                                            <building-tenants-info v-else-if="stepIndex === 11" ref="tenantsInfo" :tenantsDetails="building.tenants.tenantsDetails" :files="building.files"></building-tenants-info>
                                        </div>
                                    </div>
                                </md-step>


                                <md-step :to="fifthMajorStepPath" id="fifth" md-label="Complete" md-description="Generate Website">
                                    <div v-if="currentStep == 'complete'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <div class="md-layout-item md-small-size-100">
                                            <building-generate v-if="showGenerateConfirmation" v-on:generateWebsite="generateWebsite" v-on:save="save" v-on:done="done" :generate="building.generate" :name="building.details.name" :status="building.status" :id="id"></building-generate>
                                            <building-generating v-else-if="isGenerating" v-on:done="done" :name="building.details.name"></building-generating>
                                            <building-saved v-else-if="isSaved" v-on:done="done" v-on:showGeneratePage="showGeneratePage" :name="building.details.name"></building-saved>
                                        </div>
                                    </div>
                                </md-step>
                            </md-steppers>

                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>

                        <div v-if="!hideWizardButtons" class="stepper-buttons-wrap md-layout md-alignment-space-between">
                            <div class="md-layout-item md-alignment-top-right">
                                <md-button :disabled="disableBtns" v-if="!isStart" :to="previousUrl" class="md-raised md-primary">Back</md-button>
                            </div>
                            <div class="md-layout-item md-alignment-top-right md-layout">
                                <md-button :disabled="disableBtns" v-if="!isEnd" @click="nextClick" class="md-raised md-primary">Next</md-button>
                            </div>
                        </div>
                          
                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { FadeTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import { extend } from "vee-validate";
    import { required, email, min } from "vee-validate/dist/rules";
    extend("email", email);
    extend("required", required);
    extend("min", min);

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import stepsList from "./wizardSteps";
    import Api from '@/ts/UvApiService';
    import { BuildingStatus } from '@/ts/buildingSpec';

    //Details
    import BuildingDetails from "./Details.vue";
    import BuildingContacts from "./Contacts.vue";
    import BuildingAddress from "@/components/Company/Address.vue";

    import BuildingLocation from "./Location.vue";
    import BuildingServiceCharge from "./ServiceCharge.vue";

    //Amenities
    import BuildingAmenities from "./Amenities.vue";
    import BuildingAmenitiesDetails from "./AmenitiesDetails.vue";
    import BuildingVisitorProcess from "./VisitorProcess.vue";

    //Files
    import FilePondUpload from "./FilePondUpload.vue";
    import BuildingFilesInfo from "./FilesInfo.vue";

    //Tenants
    import BuildingTenants from "./Tenants.vue";
    import BuildingTenantsInfo from "./TenantsInfo.vue";

    import BuildingGenerate from "./Generate.vue";
    import BuildingGenerating from "./Generating.vue";
    import BuildingSaved from "./Saved.vue";

    export default {
        components: {
            FadeTransition
            , Loader
            , BuildingDetails
            , BuildingContacts
            , BuildingAddress
            , BuildingLocation
            , BuildingServiceCharge
            , BuildingAmenities
            , BuildingAmenitiesDetails
            , BuildingVisitorProcess
            , FilePondUpload
            , BuildingFilesInfo
            , BuildingTenants
            , BuildingTenantsInfo
            , BuildingGenerate
            , BuildingGenerating
            , BuildingSaved
        },
        methods: {
            showGeneratePage() {
                this.showGenerateConfirmationAtEnd = true;
            },
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this building`;
                this.$notify({
                    timeout: 10000,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            async save() {
                var res = await Api.buildings.save(this.id, this.building.generate.poNumber);
                if (res.success === true) {
                    this.building.status = BuildingStatus.saved;
                    this.showGenerateConfirmationAtEnd = this.isNeitherGeneratingNorSaved;
                }
                else {
                    this.showServerFailMessage(res, "saving");
                }
            },
            async generateWebsite() {
                var res = await Api.buildings.generate(this.id, this.building.generate.poNumber);
                if (res.success === true) {
                    this.building.status = BuildingStatus.generating;
                    this.showGenerateConfirmationAtEnd = this.isNeitherGeneratingNorSaved;
                }
                else {
                    this.showServerFailMessage(res, "generating");
                }
            },
            async saveStep() {
                this.disableBtns = true;
                if (this.currentPathInfo.path === "/buildings/:buildingId/files") { 
                   this.building.files.list = this.$refs.filePondUpload.getFiles(); 
                }
                var objData = Help.objReferenceFromString(this.building, this.currentDataPath);
                //console.log("posting");
                //console.log(objData);
                var res = await Api.buildings.upsertBuilding(this.id, objData, this.currentDataPath, this.currentStepForDto); 
                this.id = res.id;
                var relevantJson = Help.objReferenceFromString(res.json, this.currentDataPath);
                Help.objReferenceFromString(this.building, this.currentDataPath, relevantJson);//N.B. with only fragments of amentities coming back, and this merge only going one level deep--- anything but full am. data from server will trash the spec for amentites. 
                this.showGenerateConfirmationAtEnd = this.isNeitherGeneratingNorSaved;
                this.disableBtns = false;
            },
            async runCustomValidation() {
                var result = { valid: true };
                if (this.currentPathInfo.path === "/buildings/:buildingId/tenants/info") {
                    result = await this.$refs.tenantsInfo.validateTable();
                }
                else if (this.currentPathInfo.path === "/buildings/:buildingId/files") {
                    result = this.$refs.filePondUpload.validateFilePondStatus();
                }
                return result;
            },
            async nextClick() {
                var result = await this.runCustomValidation();
                if (result.valid) {
                    await this.validatePageSaveOrAlert();
                }
                else {
                    this.notifyErrors(result.errors);
                }
            },
            notifyErrors(errorsArray) {
                var errorsLis = "";

                errorsArray.forEach((e) => {
                    if (e.length > 0) { 
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });

                this.$notify({
                    timeout: 10000,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            async validatePageSaveOrAlert() {
                this.$refs.valObserver.validate().then(async success => {
                    
                        if (!success) {

                            setTimeout(() => { //TODO: update vee validate timeout here is to ensure errors are there and correct https://github.com/logaretm/vee-validate/issues/2248#issuecomment-578229806
                                this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                                //console.log(this.$refs.valObserver.errors);
                            }, 100);

                            return;
                        }
                        else {
                            await this.saveStep();
                            this.$router.push(this.nextUrl);
                        }
                });
            },
            done() {
                this.$router.push({ name: "Dashboard" });
                let msg, msgType, iconType = "";
                if (this.isGenerating) {
                    msg = `We are generating the website for <b>${this.building.details.name}</b> you'll be notified when it's online`;
                    msgType = NotyTypes[NotyTypes.success];
                    iconType = "thumb_up";
                }
                else if (this.isSaved) {
                    msg = `Your details for <b>${this.building.details.name}</b> were saved, please complete and <b>generate</b> as soon as possible`;
                    msgType = NotyTypes[NotyTypes.info];
                    iconType = "add_alert";
                }

                if (this.isGenerating || this.isSaved) {
                    setTimeout(() => {
                        this.$notify({
                            timeout: 10000,
                            message: msg,
                            icon: iconType,
                            horizontalAlign: "center",
                            verticalAlign: "top",
                            type: msgType,
                            animate: {
                                enter: 'animated fadeInDown',
                                exit: 'animated fadeOutUp'
                            }
                        });
                    }, 600);
                }
            },
            getUrlFromPattern(urlFormat) {
                return urlFormat.replace(":buildingId", this.id);
            },
            getPatternFromUrl(url) {
                return url.replace(this.id, ":buildingId");
            }
        },
        data() {
            return {
                loading: true,
                portfolioId: null,
                id: 0,
                building: null,
                showGenerateConfirmationAtEnd:true,
                isVertical: false,
                currentRoutePath: null,
                steps: stepsList,
                anyFilesUploaded: true, //TODO:wire into the data??
                stepIndex: 0,
                disableBtns: false
            }
        },
        computed: {
            pageTitle() {
                var respVal = "New Building";
                if (this.isEditMode) {
                    respVal = this.building.details.name;
                }
                return respVal;
            },
            firstMajorStepPath() {
                if (this.isEditMode) {
                    return `/buildings/${this.id}/details`;
                }
                else {
                    return `/portfolios/${this.$route.params.portfolioId}/buildings/new`; 
                }
            },
            secondMajorStepPath() {
                return `/buildings/${this.id}/amenities`;
            },
            thirdMajorStepPath() {
                return `/buildings/${this.id}/files`;
            },
            fourthMajorStepPath() {
                return `/buildings/${this.id}/tenants`;
            },
            fifthMajorStepPath() {
                return `/buildings/${this.id}/complete`;
            },
            currentPathInfo() {
                return this.steps[this.stepIndex];
            },
            currentStep() {
                return this.currentPathInfo.step;
            },
            currentDataPath() {
                return this.currentPathInfo.dataPath;
            },
            hideWizardButtons() {
                return false;//? eh?
            },
            isSaved() {
                return !Help.isNullOrUndef(this.building) && this.building.status == BuildingStatus.saved;
            },
            isGenerating() {
                return !Help.isNullOrUndef(this.building) && this.building.status == BuildingStatus.generating;
            },
            isNeitherGeneratingNorSaved() {
                return !this.isGenerating && !this.isSaved;
            },
            showGenerateConfirmation() {
                if (this.showGenerateConfirmationAtEnd) {
                    return true;
                }
                else {
                    return this.isNeitherGeneratingNorSaved;
                }
            },
            isStart: function () { return this.currentPathInfo.start ?? false; },
            isEnd: function () { return this.currentPathInfo.end ?? false; },
            nextUrl: function () { 
                var respVal = null;
                if (!this.isEnd) {
                    respVal = this.steps[this.stepIndex + 1].path;
                    respVal = this.getUrlFromPattern(respVal);
                }
                return respVal;
            },  
            previousUrl: function () { ///erm might have been easier https://github.com/vuematerial/vue-material/issues/931 haha or just flatten the steps and iterate through them keeping track of index
                var respVal = null;
                if (!this.isStart) {
                    respVal = this.steps[this.stepIndex - 1].path;
                    respVal = this.getUrlFromPattern(respVal);
                }
                return respVal;
            },
            isEditMode() {
                return Help.isGoodNumber(this.id) && this.id > 0;
            },
            currentStepForDto() {
                var fullPath = this.currentPathInfo.path;
                return fullPath.replace("/buildings/:buildingId", "");
            }
        },
        async created() {
            if (!Help.isNullOrUndef(this.$route.params.buildingId)) { //edit
                this.id = parseInt(this.$route.params.buildingId);
                var res = await Api.buildings.getBuilding(this.$route.params.buildingId);
                this.building = res;
                this.showGenerateConfirmationAtEnd = this.isNeitherGeneratingNorSaved;

                if (this.building.status == BuildingStatus.live) {
                    this.$notify({
                        timeout: 10000,
                        message: `<b>${this.building.details.name}</b> provides data for a <b>Live Tenant Website</b><br/><br/>Edits may disrupt functioning of the website<br/><br/>Please <a href='mailto:support@unitview.co.uk?subject=Live Edit Query | ${this.building.details.name}'>Contact Support</a> if you are unsure of the effect of an edit you wish to make - we will be more than happy to help you`,
                        icon: "add_alert",
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: NotyTypes[NotyTypes.warning]
                    });
                }

                this.loading = false;  
            }
            else if (Help.isNullOrUndef(this.$route.params.portfolioId)) { //wrong params
                this.loading = false;
                this.$notify({
                    timeout: 10000,
                    message: `Error you must add a building to an <b>Existing</b> <a href='#/portfolios'>Portfolio</a>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            }
            else {
                  
                    this.$notify({
                        timeout: 10000,
                        message: `This Wizard will save changes whenever you progress a step with the Next button`,
                        icon: "add_alert",
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: NotyTypes[NotyTypes.info]
                    });

                this.building = await Api.buildings.getEmptyBuilding(this.$route.params.portfolioId); //new
                this.showGenerateConfirmationAtEnd = true;

                this.loading = false;
            }
        },
        async mounted() {
            this.$nextTick().then(() => {
                this.currentRoutePath = this.$route.path;
            });
        },
        watch: {
            '$route'() {
                this.$nextTick(function () { 
                    this.currentRoutePath = this.$route.path;
                });
            },
            currentRoutePath(v) {
                if (this.isEditMode) {
                    var path = this.getPatternFromUrl(v);
                    this.stepIndex = this.steps.findIndex(function (item) { return item.path === path; });
                }
                else {
                    this.stepIndex = 0;
                }
            }
        }
    }
</script>



<style lang="scss">

   
</style>

<!--maybe should have used cref https://vuejs.org/v2/guide/components.html#Dynamic-Components-->
